export default {
  title: 'OFFER LIMITS',
  items: {
    ConsumerOfferLimitChange: {
      label: 'Consumer Offer Limit Change',
      type: 'integer',
      unit: 'percent'
    },
    ProviderOfferLimitChange: {
      label: 'Provider Offer Limit Change',
      type: 'integer',
      unit: 'percent'
    },
    OfferLimitThreshold: {
      label: 'Offer Limit Threshold',
      type: 'integer',
      unit: '%'
    },
    OfferLimitFraudDetection: {
      label: 'Fraud Detection Limit',
      type: 'integer',
      unit: '$'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/offer-limits.js